export default __webpack_public_path__ + "static/media/protester.f19862fc.png";